var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H27.9954C32.4136 0 35.9954 3.58172 35.9954 8V27.9954C35.9954 32.4136 32.4136 35.9954 27.9954 35.9954H8C3.58172 35.9954 0 32.4136 0 27.9954V8Z",
    fill: "#F3E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3269 25.4928V23.8272C21.3269 22.9438 20.976 22.0965 20.3513 21.4718C19.7266 20.8471 18.8793 20.4961 17.9958 20.4961H12.9991C12.1156 20.4961 11.2683 20.8471 10.6436 21.4718C10.0189 22.0965 9.66797 22.9438 9.66797 23.8272V25.4928",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4991 17.1652C17.3388 17.1652 18.8302 15.6738 18.8302 13.8341C18.8302 11.9943 17.3388 10.5029 15.4991 10.5029C13.6594 10.5029 12.168 11.9943 12.168 13.8341C12.168 15.6738 13.6594 17.1652 15.4991 17.1652Z",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3265 25.4929V23.8274C26.3259 23.0893 26.0803 22.3723 25.6281 21.789C25.1759 21.2056 24.5428 20.789 23.8281 20.6045",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 10.6108C22.0447 10.7943 22.6798 11.211 23.1333 11.7953C23.5868 12.3796 23.833 13.0982 23.833 13.8379C23.833 14.5775 23.5868 15.2961 23.1333 15.8804C22.6798 16.4647 22.0447 16.8814 21.3281 17.0649",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerBlue);
export default __webpack_public_path__ + "static/media/customerBlue.5ccb0a37e26b49e14764efa1c2dbd4f1.svg";
export { ForwardRef as ReactComponent };